const $inject = [];
const lbaTagInput = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '=',
      name: '=',
      cake: '=',
      indexArray: '@'
    },
    bindToController: true,
    controller: 'lbaTagInputCtrl',
    controllerAs: 'vm',
    template: require('./lbaTagInput.html')
  }
};

lbaTagInput.$inject = $inject;

export default lbaTagInput;



// WEBPACK FOOTER //
// ./src/components/lbaTagInput/lbaTagInputDir.js